// Handle name object / string //
export const handleName = (
  name: string | { en?: string; fr?: string }
): string => {
  if (typeof name === 'string') return name
  if (typeof name === 'object') return name.en ?? ''
  return ''
}

// Sort array of objects by key
export function sortArrayOfObjectsByKey<T>(array: T[], key: keyof T): T[] {
  return array.sort((a, b) => {
    const aValue = String(a[key]).toLowerCase()
    const bValue = String(b[key]).toLowerCase()
    if (aValue < bValue) {
      return -1
    } else if (aValue > bValue) {
      return 1
    }
    return 0
  })
}

// Sleep promise
export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

// Get sum of number fields in an array of objects - optional condition function //
export function getSumOfObjectFieldsInArray<
  I extends Record<k, number>,
  k extends string
>(data: I[], key: k, condition?: (item: I) => boolean) {
  return data.reduce((total, item) => {
    if (condition && !condition(item)) return total
    return total + (item[key] || 0)
  }, 0)
}

// Find distance between 2 coordinates
export function distance(
  pointA: {
    x: number
    y: number
  },
  pointB: {
    x: number
    y: number
  }
) {
  const x = Math.abs(pointA.x - pointB.x),
    y = Math.abs(pointA.y - pointB.y)
  const distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2))
  return distance
}

export function distance3D(
  pointA: {
    x: number
    y: number
    z: number
  },
  pointB: {
    x: number
    y: number
    z: number
  }
) {
  const x1 = pointA.x
  const y1 = pointA.y
  const z1 = pointA.z

  const x2 = pointB.x
  const y2 = pointB.y
  const z2 = pointB.z

  const distance = Math.pow(
    Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2) + Math.pow(z2 - z1, 2),
    0.5
  )

  return distance
}

// Text //
export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

// Change value based on min & max limits
export const setLimits = (
  value: number | string | null | undefined,
  min?: number,
  max?: number
) => {
  if (value === undefined || value === '' || value === null) return
  if (parseInt(String(value)) === 0) {
    return
  }
  let num = Number(value)
  if (min !== undefined && num < min) {
    num = min
  } else if (max !== undefined && num > max) {
    num = max
  }

  return num
}

// Milliseconds to formatted hours minutes and seconds string
export function milToFormat(
  value: number | string,
  options: { colon?: boolean }
) {
  const parsed = typeof value === 'string' ? Number(value) : value
  // Clamp negatives to zero so a negative span never renders as '0-1:0-1:00'.
  const ms = parsed > 0 ? parsed : 0
  const totalSeconds = Math.floor(ms / 1000)

  const seconds = totalSeconds % 60
  const minutes = Math.floor(totalSeconds / 60) % 60
  const hours = Math.floor(totalSeconds / 3600) % 24

  const sHours = hours < 10 ? `0${hours}` : `${hours}`
  const sMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`
  const sSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`

  return `${sHours}${options.colon ? ':' : ''}${sMinutes}${
    options.colon ? ':' : ''
  }${sSeconds}`
}
